import { getEmptyUrval } from '../../../Utils/urvalUtils';
import { ClientAttributeDataType } from '../../../../../Types/ClientModelTypes';
import { IUIUrval, NodeUrvalType } from '../../../../../Types/UrvalTypes';
import { AvenyCollectionMap } from '../../../../../Model/ModelContext/ModelContext';
import { convertTEDUrvalToUIUrval } from '../../../Utils/convertTEDUrvalToUIUrval';
import Logger, { namedError } from '../../../../../Utils/Logger';
import { Result } from 'true-myth';

export const isStringType = (dataType: ClientAttributeDataType) =>
  dataType === 'String' ||
  dataType === 'Date' ||
  dataType === 'DateTime' ||
  dataType === 'ID' ||
  dataType === 'Time';

export const isNumericType = (dataType: ClientAttributeDataType) =>
  dataType === 'Int' || dataType === 'Float' || dataType === 'Currency';

export const tryConvertUrval = (
  savedUrval: NodeUrvalType | null | undefined,
  collectionName: string,
  collectionMap: AvenyCollectionMap
): Result<IUIUrval, string> => {
  if (savedUrval?.conditions) {
    const convertedUrvalResult = convertTEDUrvalToUIUrval(
      collectionName,
      JSON.parse(savedUrval.conditions),
      collectionMap,
      savedUrval
    );
    return convertedUrvalResult.map<IUIUrval>(convertedUrval => ({
      ...convertedUrval,
      savedUrvalProps: {
        id: savedUrval.id,
        namn: savedUrval.namn,
        anvFavorit: false, // TODO: Get this from somewhere
        collection: savedUrval.collection,
        order: savedUrval.order,
        rutinID: savedUrval.rutinID,
        synligAnvID: savedUrval.synligAnvID,
        synligGruppID: savedUrval.synligGruppID,
        synlighet: savedUrval.synlighet,
        urvalID: savedUrval.urvalID,
        beskrivning: savedUrval.beskrivning,
      },
    }));
  } else {
    Logger.error(Error('Urval does not have any conditions'));
    return Result.ok(getEmptyUrval());
  }
};
export const convertUrval = (
  savedUrval: NodeUrvalType | null | undefined,
  collectionName: string,
  collectionMap: AvenyCollectionMap
): IUIUrval =>
  tryConvertUrval(savedUrval, collectionName, collectionMap).unwrapOr({
    pages: [],
  });

export const convertUrvalLogError = (
  savedUrval: NodeUrvalType,
  collectionName: string,
  collectionMap: AvenyCollectionMap,
  errorMessage: string
): IUIUrval =>
  tryConvertUrval(savedUrval, collectionName, collectionMap).unwrapOrElse(
    err => {
      Logger.error(namedError('ConvertUrval', errorMessage, err));
      return {
        pages: [],
      };
    }
  );
